import { render, staticRenderFns } from "./VLoaderButton.vue?vue&type=template&id=7e525f4a&scoped=true&lang=pug&functional=true"
import script from "./VLoaderButton.vue?vue&type=script&lang=js"
export * from "./VLoaderButton.vue?vue&type=script&lang=js"
import style0 from "./VLoaderButton.vue?vue&type=style&index=0&id=7e525f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7e525f4a",
  null
  
)

export default component.exports